export class EvaluationDataProcessor {
  constructor(store) {
    this.store = store;
  }

  commitInitialData(initialData) {
    this.store.commit('evaluation/setInitialData', initialData);
  }

  commitDebtor(debtor) {
    this.store.commit('evaluation/setDebtor', debtor);
  }

  commitSimulation(simulation) {
    this.store.commit('evaluation/setSimulation', simulation);
  }

  commitIncome(income) {
    this.store.commit('evaluation/setIncome', income);
  }
}
